import React from 'react';
import { useGetDVValidatorQuery, useGetModuleCalcQuery, useGetModuleTelegramQuery } from 'Services/api/mircoservicesApi';
import { Heading, Label, Pane } from 'evergreen-ui';
import { createUseStyles } from 'react-jss';
import { useGetActuatorInfoQuery } from 'Services/api/backendVersionApi';
import { IconStatus } from './IconStatus';

const useStyles = createUseStyles({
  statusPane: {
    display: 'grid',
    gridTemplateColumns: 'minmax(max-content, 500px) max-content',
    alignItems: 'center',
    padding: '.2rem .5rem .2rem .5rem',
  },
  statusCellLabel: {
    fontWeight: 'normal',
    marginLeft: '1rem',
  },
});

export function FrontendVersion() {
  const appVersion = process.env.REACT_APP_VERSION;

  const moduleObject = React.useMemo(() => {
    const moduleName = 'Интерфейс';

    const defaultObject = {
      [moduleName]: {
        version: null,
        status: null,
        module: {},
        errorStatus: null,
      },
    };

    if (appVersion) {
      defaultObject[moduleName].version = appVersion;
    } else {
      defaultObject[moduleName].version = null;
    }

    return defaultObject;
  }, [appVersion]);

  return (
    <RenderModule
      module={moduleObject}
    />
  );
}
export function BackendVersion() {
  const { data: backendInfo = {}, isFetching, isError } = useGetActuatorInfoQuery();

  const moduleObject = React.useMemo(() => {
    const moduleName = 'Сервер';

    const defaultObject = {
      [moduleName]: {
        version: null,
        status: null,
        module: {},
        errorStatus: null,
      },
    };

    if (!isError) {
      defaultObject[moduleName].version = backendInfo?.build?.version;
    } else {
      defaultObject[moduleName].version = null;
    }

    return defaultObject;
  }, [backendInfo, isError]);

  return (
    <RenderModule
      module={moduleObject}
      isFetchingStatus={isFetching}
    />
  );
}

export function TelegramModule() {
  const {
    data: telegramModuleStatus,
    isFetching: isFetchingTelegramStatus,
    error: errorTelegramStatus,
  } = useGetModuleTelegramQuery('status');
  const { data: telegramModuleInfo, isFetching: isFetchingTelegramInfo } = useGetModuleTelegramQuery('info');

  const moduleObject = React.useMemo(() => {
    const moduleName = 'Модуль формирования телеграмм';

    const defaultObject = {
      [moduleName]: {
        version: null,
        status: null,
        module: {
          core: 'Доступ к ядру',
          coreAccess: 'UNKNOWN',
          coreDetails: null,

          calcModule: 'Модуль расчета',
          calcAccess: 'UNKNOWN',
          calcDetails: null,

          rabbitMq: 'Доступ к брокеру сообщений',
          rabbitMqAccess: 'UNKNOWN',
          rabbitMqDetails: null,
        },
        errorStatus: null,
      },
    };

    if (!errorTelegramStatus) {
      defaultObject[moduleName].version = telegramModuleInfo && telegramModuleInfo?.build?.version;
      defaultObject[moduleName].status = telegramModuleStatus?.status;
      defaultObject[moduleName].module = {
        ...defaultObject[moduleName].module,
        coreAccess: telegramModuleStatus?.components?.coreModule?.status,
        coreDetails: telegramModuleStatus?.components?.coreModule?.details ? telegramModuleStatus?.components?.coreModule?.details['detail:'] : null,

        calcAccess: telegramModuleStatus?.components?.calcModule?.status,
        calcDetails: telegramModuleStatus?.components?.calcModule?.details ? telegramModuleStatus?.components?.calcModule?.details['detail:'] : null,

        rabbitMqAccess: telegramModuleStatus?.components?.rabbitMq?.status,
        rabbitMqDetails: telegramModuleStatus?.components?.rabbitMq?.details ? telegramModuleStatus?.components?.rabbitMq?.details['detail:'] : null,
      };
    } else {
      defaultObject[moduleName].errorStatus = errorTelegramStatus?.message;
    }

    return defaultObject;
  }, [errorTelegramStatus, telegramModuleInfo, telegramModuleStatus]);

  return (
    <RenderModule
      module={moduleObject}
      isFetchingStatus={isFetchingTelegramStatus}
      isFetchingInfo={isFetchingTelegramInfo}
    />
  );
}

export function ValidationModule() {
  const {
    data: dvValidatorStatus,
    isFetching: isFetchingValidatorStatus,
    error: errorValidatorStatus,
  } = useGetDVValidatorQuery('status');
  const { data: dvValidatorInfo, isFetching: isFetchingValidatorInfo } = useGetDVValidatorQuery('info');

  const moduleObject = React.useMemo(() => {
    const moduleName = 'Модуль валидации данных';

    const defaultObject = {
      [moduleName]: {
        version: null,
        status: null,
        module: {
          core: 'Доступ к ядру',
          coreAccess: 'UNKNOWN',
          coreDetails: null,

          rabbitMq: 'Доступ к брокеру сообщений',
          rabbitMqAccess: 'UNKNOWN',
          rabbitMqDetails: null,
        },
        errorStatus: null,
      },
    };

    if (!errorValidatorStatus) {
      defaultObject[moduleName].version = dvValidatorInfo && dvValidatorInfo?.build?.version;
      defaultObject[moduleName].status = dvValidatorStatus?.status;
      defaultObject[moduleName].module = {
        ...defaultObject[moduleName].module,
        coreAccess: dvValidatorStatus?.components?.coreModule?.status,
        coreDetails: dvValidatorStatus?.components?.coreModule?.details ? dvValidatorStatus?.components?.coreModule?.details['detail:'] : null,

        rabbitMqAccess: dvValidatorStatus?.components?.rabbitMq?.status,
        rabbitMqDetails: dvValidatorStatus?.components?.rabbitMq?.details ? dvValidatorStatus?.components?.rabbitMq?.details['detail:'] : null,
      };
    } else {
      defaultObject[moduleName].errorStatus = errorValidatorStatus?.message;
    }
    return defaultObject;
  }, [errorValidatorStatus, dvValidatorInfo, dvValidatorStatus]);

  return (
    <RenderModule
      module={moduleObject}
      isFetchingStatus={isFetchingValidatorStatus}
      isFetchingInfo={isFetchingValidatorInfo}
    />
  );
}

export function CalcModule() {
  const {
    data: calcModuleStatus,
    isFetching: isFetchingCalcStatus,
    error: errorCalcStatus,
  } = useGetModuleCalcQuery('status');
  const { data: calcModuleInfo, isFetching: isFetchingCalcInfo } = useGetModuleCalcQuery('info');
  const moduleObject = React.useMemo(() => {
    const moduleName = 'Модуль расчета данных';

    const defaultObject = {
      [moduleName]: {
        version: null,
        status: null,
        module: {
          core: 'Доступ к ядру',
          coreAccess: 'UNKNOWN',
          coreDetails: null,
        },
        errorStatus: null,
      },
    };

    if (!errorCalcStatus) {
      defaultObject[moduleName].version = calcModuleInfo && calcModuleInfo?.build?.version;
      defaultObject[moduleName].status = calcModuleStatus?.status;
      defaultObject[moduleName].module = {
        ...defaultObject[moduleName].module,
        coreAccess: calcModuleStatus?.components?.coreModule?.status,
        coreDetails: calcModuleStatus?.components?.coreModule?.details ? calcModuleStatus?.components?.coreModule?.details['detail:'] : null,
      };
    } else {
      defaultObject[moduleName].errorStatus = errorCalcStatus?.message;
    }
    return defaultObject;
  }, [errorCalcStatus, calcModuleInfo, calcModuleStatus]);

  return (
    <RenderModule module={moduleObject} isFetchingStatus={isFetchingCalcStatus} isFetchingInfo={isFetchingCalcInfo} />
  );
}

function RenderModule({ module, isFetchingStatus, isFetchingInfo }) {
  const classes = useStyles();
  const isFetching = isFetchingStatus || isFetchingInfo;

  return (
    React.Children.toArray(Object.entries(module).map(([key, value]) => (
      <>
        <Pane className={classes.statusPane}>
          <Heading>
            {`${key}: ${value.version ? `v${value.version}` : '...'}`}
          </Heading>
          <IconStatus
            param={value.version ? 'UP' : null}
            errors={value.errorStatus || 'Активен'}
            isFetching={isFetching}
          />
        </Pane>

        {
          value.module.core && (
          <Pane className={classes.statusPane}>
            <Label className={classes.statusCellLabel}>
              {value.module.core}
            </Label>
            <IconStatus
              param={value.module.coreAccess ? value?.module?.coreAccess : null}
              errors={value.module.coreDetails || 'Активен'}
              isFetching={isFetching}
            />
          </Pane>
          )
        }

        {
          value.module.calcModule && (
            <Pane className={classes.statusPane}>
              <Label className={classes.statusCellLabel}>
                {value.module.calcModule}
              </Label>
              <IconStatus
                param={value.module.calcAccess ? value.module.calcAccess : null}
                errors={value.module.calcDetails || 'Активен'}
                isFetching={isFetching}
              />
            </Pane>
          )
        }

        {
          value.module.rabbitMqAccess && (
            <Pane className={classes.statusPane}>
              <Label className={classes.statusCellLabel}>
                {value.module.rabbitMq}
              </Label>
              <IconStatus
                param={value.module.rabbitMqAccess ? value?.module?.rabbitMqAccess : null}
                errors={value.module.rabbitMqDetails || 'Активен'}
                isFetching={isFetching}
              />
            </Pane>
          )
        }

      </>
    ))));
}
